<template>
  <div class="olympiad-prizes__container">
    <h2>Награды</h2>

    <div class="olympiad-prizes">
      <div
        v-for="(prize, index) in prizes"
        :key="index"
        class="olympiad-prizes__item"
      >
        <h5>{{ prize.position }} место</h5>
        <img
          v-if="prize.olympiadPrize.image"
          :src="prize.olympiadPrize.image.url"
          :alt="prize.position"
        >
        <p>{{ prize.olympiadPrize.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OlympiadPrizes',
  props: {
    prizes: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">

.olympiad-prizes__container {
  h2 {
    margin-bottom: calc(var(--scale) * 24);
    font-weight: 600;
    font-size: calc(var(--scale) * 24);
    line-height: 150%;
    color: #02120F;
  }
}

.olympiad-prizes {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: calc(var(--scale) * 33);
  background-color: #FFFCCC;
  border-radius: calc(var(--scale) * 40);
  padding: calc(var(--scale) * 20) calc(var(--scale) * 33);

  @include media-down($size-tablet) {
    flex-direction: column;
    border-radius: calc(var(--scale) * 20);
    gap: calc(var(--scale) * 40);
    padding-inline: calc(var(--scale) * 28);
  }

  &__item {
    width: calc(100% / 3 - var(--scale) * 33 * 2 / 3);
    display: flex;
    align-items: center;
    flex-direction: column;

    @include media-down($size-tablet) {
      width: 100%;
    }

    h5 {
      min-width: calc(var(--scale) * 70);
      padding: calc(var(--scale) * 2) calc(var(--scale) * 12);
      background-color: #FF5319;
      border-radius: 100px;
      font-weight: 500;
      font-size: calc(var(--scale) * 20);
      line-height: 130%;
      text-align: center;
      color: #FFFFFF;
    }

    img {
      margin-block: calc(var(--scale) * 16) calc(var(--scale) * 21);
      width: 100%;
      height: calc(var(--scale) * 177);
      border-radius: calc(var(--scale) * 10);
      object-fit: cover;

      @include media-down($size-tablet) {
        margin-block: calc(var(--scale) * 18) calc(var(--scale) * 15);
        height: calc(var(--scale) * 146);
      }

      @include media-down($size-tablet) {
        height: calc(var(--scale) * 219);
      }
    }

    p {
      min-width: calc(var(--scale) * 100);
      padding: calc(var(--scale) * 2) calc(var(--scale) * 12);
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid #FFFFFF;
      border-radius: 100px;
      font-weight: 500;
      font-size: calc(var(--scale) * 16);
      text-align: center;
      line-height: 130%;
      color: #092A48;
    }
  }
}

</style>
